export const localStorageKey = clientId => `ADVWorkflow.DoYouHaveChildrenAnswered[${clientId}]`;

const shouldSkip = (isGoingForward, alreadyHadChildrenData, clientId) => {
  if (
    isGoingForward &&
    (alreadyHadChildrenData || localStorage.getItem(localStorageKey(clientId)) === 'true')
  ) {
    return true;
  }
  return false;
};

export default shouldSkip;
